import { useMemo } from 'react'
import { getAuditLog } from '../../lib/store'
import { formatDate } from '../../lib/calculations'

export default function AuditTab({ department }) {
  const logs = useMemo(() => getAuditLog(department), [department])

  return (
    <div className="space-y-4">
      {logs.length === 0 ? (
        <p className="text-gray-600 text-sm text-center py-8">No audit entries yet</p>
      ) : (
        <div className="space-y-2">
          {logs.map(log => (
            <div key={log.id} className="bg-gray-800/50 rounded px-4 py-3 text-sm">
              <div className="flex items-center gap-3">
                <span className="text-xs text-gray-500">{formatDate(log.createdAt)}</span>
                <span className="text-xs font-mono bg-gray-700 px-1.5 py-0.5 rounded">{log.action}</span>
                {log.tableName && <span className="text-xs text-gray-400">{log.tableName}</span>}
              </div>
              {log.newValue && (
                <p className="text-xs text-gray-500 mt-1">{JSON.stringify(log.newValue)}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
